import { DatePipe } from "@angular/common";
import {
  Component,
  OnInit,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CookieService } from "src/app/core/services/cookie.service";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-add-area-alert',
  templateUrl: './add-area-alert.component.html',
  styleUrls: ['./add-area-alert.component.scss']
})
export class AddAreaAlertComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  areaAlert: FormGroup;
  submitted: boolean;
  currentUser: any;
  notfoundshow: boolean;
  isLoading: boolean =false;
  isLoading1: boolean;
  keyword = "name";
  keyword1 = "Area";
  areas: any;
  propertyType: any;
  bankList: any;
  UserID: any;
  PropertyId: any;
  initialValue = "";
  loanTypes: any;
  DistrictList: any;
  StateList: any[];
  baseDocType: any;
  date: Date = new Date();
  fieldsData: any[];
  DataList: any = {};
  URL: string;
  dynamicFields = [];
  stateID: any;
  isImageUploaded = false;
  StateBaseDocType: any;
  param: string;
  PropertyData: any;
  Editproperty: boolean;
  Type: any;
  id: any;
  StateList_1: any[];
  constructor(private service: GeneralService,
    private route: ActivatedRoute,
    private cookie: CookieService,
    private datepipe: DatePipe,
    private Fb: FormBuilder,
    private router: Router) { 
      this.Type = this.route.snapshot.params.type;

      if (this.router.getCurrentNavigation()) {
        if (this.router.getCurrentNavigation().extras.state) {
          const state = this.router.getCurrentNavigation().extras.state;
  
          this.UserID = state["UserId"];
          // console.log("line=91", this.UserID);

          localStorage.setItem("UserID", state.UserId);
          this.id = state["id"];
  
          localStorage.setItem("id", state.id);
        } else {
          if (localStorage.getItem("UserID")) {
            this.UserID = localStorage.getItem("UserID");
          }
        }
      }
      // console.log("UserID", this.UserID);
     
      if (this.Editproperty == true) {
        this.Type = "edit";
        this.breadCrumbItems = [
          { label: "Area-Alert", path: "/users/area-alert-list" },
          { label: "Edit Area-Alert", path: "/", active: true },
        ];
      } else {
        this.breadCrumbItems = [
          { label: "Area-Alert", path: "/users/area-alert-list" },
          { label: "Add Area-Alert", path: "/", active: true },
        ];
      }
    }

  ngOnInit() {
    this.currentUser = JSON.parse(this.cookie.getCookie("currentUser"));
    
    this.getNoticeData(this.UserID);
    this.submitted = false;
    this.currentUser = this.service.getcurrentUser();
    this.areaAlert = this.Fb.group({
      UserID: new FormControl(this.UserID),
      DistrictID: new FormControl(''),
      TalukaID: new FormControl(null),
      villageid: new FormControl(''),
      area: new FormControl(null,Validators.required),
      districtname : new FormControl(null),
      villagename: new FormControl(null),
      Talukaname: new FormControl(null),
    });  
     this.fetchdistrictlist();
  }
  getNoticeData(id) {
    // console.log("id", id);
    // this.isLoading = true;
    if (this.Type === "edit") {

           this.isLoading = true;

      this.service.FetchAreaDeatail(id,this.id).subscribe((res) => {
        
        this.isLoading = false;
        this.setNoticeData(res);
        console.log('Noticedata',res)
      });
    }
  }
  setNoticeData(data: any) {
    // console.log("line",data.result[0])
    this.PropertyData = data.result[0];
    this.areaAlert.patchValue(this.PropertyData)
    this.areaAlert.controls.area.setValue(this.PropertyData.villagename + ',' + this.PropertyData.Talukaname + ',' + this.PropertyData.districtname)
    
    this.areaAlert.controls.Talukaname.setValue(this.PropertyData.Talukaname);
    this.areaAlert.controls.villagename.setValue(this.PropertyData.villagename);
    this.areaAlert.controls.districtname.setValue(this.PropertyData.districtname);
    this.areaAlert.controls.villageid.setValue(this.PropertyData.village)
    this.areaAlert.controls.DistrictID.setValue(this.PropertyData.district);
    this.areaAlert.controls.TalukaID.setValue(this.PropertyData.taluka);


  }
  Save(){
    this.submitted = true;
    if(this.areaAlert.valid){
      this.submitted = false;
      delete this.areaAlert.value.area;
      if(this.Type !== 'edit'){
        this.service.addAreaAlert(this.areaAlert.value).subscribe((res:any)=>{
          this.submitted = false;
          if(res.status == 400){
            Swal.fire({
              position: "top-end",
              type: "info",
              title: res.Message,
              showConfirmButton: false,
              timer: 1500,
            });
      
            this.router.navigate(["users/area-alert-list"]);
          }else{
            Swal.fire({
              position: "top-end",
              type: "success",
              title: res.Message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.isLoading = false;
            this.router.navigate(["users/area-alert-list"]);
          }
        })
      }else{
        this.service.editAreaAlert(this.id,this.areaAlert.value).subscribe((res:any)=>{
           this.submitted = false;
          if(res.status == 400){
            Swal.fire({
              position: "top-end",
              type: "info",
              title: res.Message,
              showConfirmButton: false,
              timer: 1500,
            });
      
            this.router.navigate(["users/area-alert-list"]);
          }else{
            Swal.fire({
              position: "top-end",
              type: "success",
              title: res.Message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.isLoading = false;
            this.router.navigate(["users/area-alert-list"]);
          }
        })
      }
    }
  }


  get f() {
    return this.areaAlert.controls;
  }
  fetchdistrictlist() {
    this.service.getDistrictlist(this.UserID).subscribe((res:any)=>{
      this.StateList = res.data
    })
  }


  resetFields() {
    this.areaAlert.reset()
    this.submitted = false;
  }
  selectEvent(item:any){
    // console.log('Item',item)
    const area= item.area.split(',')
    this.areaAlert.controls.Talukaname.setValue(area[1]);
    this.areaAlert.controls.villagename.setValue(area[0]);
    this.areaAlert.controls.districtname.setValue(area[2]);
    this.areaAlert.controls.villageid.setValue(item.villageid)
    this.areaAlert.controls.DistrictID.setValue(item.DistrictID);
    this.areaAlert.controls.TalukaID.setValue(item.TalukaID);
  }



}
